import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/en.json';
import growth from '@post-office/team-package--i18n--growth/i18n/en.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/en.json';

export default {
	...postOfficeTemplate,
	...growth,
	...testMessages
}
